import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = environment.authToken?.trim();

  if (!token || !isApiRequest(req.url)) {
    return next(req);
  }

  const clonedRequest = req.clone({
    setHeaders: {
      Authorization: token,
    },
  });

  return next(clonedRequest);
};

const isApiRequest = (requestUrl: string): boolean => {
  const apiBaseUrls = [environment.apiURLNew?.trim(), environment.apiURLWebServices?.trim()].filter(
    (url): url is string => Boolean(url),
  );

  if (apiBaseUrls.length === 0) {
    return false;
  }

  return apiBaseUrls.some((apiBaseUrl) => requestUrl.startsWith(apiBaseUrl));
};
